window.addEventListener('load', () => {
  function setServiceOption() {
    const serviceOptions = document.querySelectorAll('.service-option-tab__content');

    serviceOptions.forEach((serviceOpt) => {
      const serviceCode = serviceOpt.getAttribute('id');
      let titleCode = 't1';
      let valueCode = 'v1';

      const selects = serviceOpt.querySelectorAll('select');
      const prices = serviceOpt.querySelectorAll('.service-option__price');
      const priceDisplayed = serviceOpt.querySelector('.service-option__price--displayed');
      const savings = serviceOpt.querySelectorAll('.service-option__savings');
      const savingDisplayed = serviceOpt.querySelector('.service-option__saving--displayed');
      const descriptions = serviceOpt.querySelectorAll('.service-option__description');
      const descriptionDisplayed = serviceOpt.querySelector('.service-option__description--displayed');
      const bookings = serviceOpt.querySelectorAll('.service-option__booking');

      // NEW: the direct link element
      const bookLink = serviceOpt.querySelector('.service-option__book-link');

      selects.forEach((select) => {
        select.addEventListener('change', function () {
          const option = this.options[this.selectedIndex];
          const dataCombo = option.getAttribute('data-combo');

          if (dataCombo.includes('t')) {
            titleCode = dataCombo;
          } else {
            valueCode = dataCombo;
          }

          const comboCode = serviceCode + '_' + titleCode + valueCode;

          // Update displays
          setData(prices, priceDisplayed, comboCode);
          setData(savings, savingDisplayed, comboCode);
          setData(descriptions, descriptionDisplayed, comboCode);
          setData(bookings, bookLink, comboCode, 'booking');
        });
      });

      // Initial render
      let comboCode = serviceCode + '_' + titleCode + valueCode;
      setData(prices, priceDisplayed, comboCode);
      setData(savings, savingDisplayed, comboCode);
      setData(descriptions, descriptionDisplayed, comboCode);
      setData(bookings, bookLink, comboCode, 'booking');

      function setData(arr, target, comboCode, kind = '') {
        arr.forEach((el) => {
          if (el.getAttribute('data-combination') === comboCode) {
            if (kind === 'booking') {
              const url = (el.value || '').trim();

              if (url) {
                // same tab by default
                target.setAttribute('href', url);
                target.removeAttribute('aria-disabled');
              } else {
                target.setAttribute('href', '#');
                target.setAttribute('aria-disabled', 'true');
              }
              return; // done for booking
            }

            // price/saving/description handling (unchanged)
            if (el.classList.contains('service-option__savings')) {
              if (el.value === 'NA' || el.value === '0' || el.value === '') {
                target.parentElement.style.display = 'none';
              } else {
                target.parentElement.style.display = 'flex';
                target.innerHTML = el.value;
              }
            } else {
              target.innerHTML = el.value;
            }
          }
        });
      }

      serviceOpt.classList.replace('is-loading', 'has-loaded');
    });
  }

  setServiceOption();
});
